module.exports = __webpack_public_path__ + "static/img/icon-workbench-dropdown.1da2950a.png";